<template>
  <div
    :class="[
      'fixed left-1/2 -translate-x-1/2 z-50 sm:w-[400px] w-[90vw] p-4',
      'rounded-lg shadow-[0_4px_6px_0_rgba(0,0,0,0.05),0_10px_20px_0_rgba(0,0,0,0.12)] bg-[rgba(30,27,43,0.80)] backdrop-blur-[7px]  border border-n-600'
    ]"
  >
    <div class="flex items-center gap-3">
      <div class="flex-shrink-0">
        <l-icon :name="iconName" size="large" :class="iconColor" />
      </div>
      <div class="flex-1 min-w-0">
        <div class="body-3">
          {{ title }}
        </div>
        <div v-if="message" class="body-4 text-n-300">
          {{ message }}
        </div>
      </div>
      <l-button v-if="actionText" type="primary" size="small" @click="handleAction">
        {{ actionText }}
      </l-button>
      <l-icon name="close" size="large" @click="$emit('close')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { LButton, LIcon, type LIconName } from '@last/core-ui/paprika'

import type { ToastType } from './toast'

const props = withDefaults(
  defineProps<{
    message?: string
    type?: ToastType
    title: string
    actionText?: string
    onAction?: () => void
  }>(),
  {
    type: 'info',
    message: undefined,
    actionText: undefined,
    onAction: undefined
  }
)

const emit = defineEmits<{
  close: []
}>()

const iconName = computed<LIconName>(() => {
  const icons: Record<ToastType, LIconName> = {
    success: 'check-circle',
    error: 'close-circle',
    warning: 'alert-circle',
    info: 'information'
  }
  return icons[props.type]
})

const iconColor = computed<string>(() => {
  const colors: Record<ToastType, string> = {
    success: 'text-g-500',
    error: 'text-r-500',
    warning: 'text-y-500',
    info: 'text-b-500'
  }
  return colors[props.type]
})

function handleAction() {
  if (props.onAction) {
    props.onAction()
  }
  emit('close')
}
</script>
